function setProductCardListeners() {
  const subExclusiveProductCards = document.querySelectorAll(".subscriber-exclusive-product-card");

  if (subExclusiveProductCards.length > 0) {
    const subscriberType = window.subscriberType;

    subExclusiveProductCards.forEach(card => {
      const productName = card.querySelector(".product-card-title a")?.textContent;
      const quickBuyButton = card.querySelector(".product-card-redesign__quick-buy");
      const userIsEligible = quickBuyButton ? true : false;
      const path = window.location.href;

      card.addEventListener('click', () => {
       Shopify.analytics.publish("rudderstack_track", {
          eventName: "Subscriber Exclusive Product Card Clicked",
          eventData: {
            productName,
            userIsEligible,
            path,
            subscriberType
          }
        });
      });
    });
  }
}

document.addEventListener("DOMContentLoaded", setProductCardListeners);